import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '@SiteComponents/Button'
import Close from '@Images/bulk_action_bar_close.svg'
import Add from '@Images/bulk_action_bar_add.svg'
import Delete from '@Images/bulk_action_bar_delete.svg'

import {
  unselectAccountUsers,
  deleteAccountUsers,
} from '@SiteModules/AccountUser/actions'

import {
  openManageWorkspaceAccessPopup,
} from '@SiteModules/Popup/actions'

import {
  getSelectedAccountUserIds,
  getSelectedAccountUserUserIds,
} from '@SiteModules/AccountUser/selectors'

import {
  getUserId,
} from '@SiteModules/User/selectors'

import './AccountUsersBulkActionBar.scss'

const BAR_WIDTH = 911 // px, as in AccountUsersBulkActionBar width
const SETTINGS_MAIN_MARGIN_WIDTH = 32 // px, as in SettingsMain.scss

const AccountUsersBulkActionBar: React.FC = () => {
  const dispatch = useDispatch()

  const selectedAccountUserIds = useSelector(getSelectedAccountUserIds)
  const selectedAccountUserUserIds = useSelector(getSelectedAccountUserUserIds)
  const userId = useSelector(getUserId)
  const ownAccountUserSelected = selectedAccountUserUserIds.includes(userId)
  const shouldAllowToDelete = !ownAccountUserSelected

  const numberOfSelectedAccountUsers = selectedAccountUserIds.length

  const tableElement = document.getElementsByClassName('AccountUsersTable')[0] as HTMLDivElement | undefined
  const sidebarElement = document.getElementsByClassName('Sidebar')[0] as HTMLDivElement | undefined
  const settingsMenuElement = document.getElementsByClassName('SettingsMenu')[0] as HTMLDivElement | undefined

  const tableWidth = tableElement?.offsetWidth || 0
  const sidebarWidth = sidebarElement?.offsetWidth || 0
  const settingsMenuWidth = settingsMenuElement?.offsetWidth || 0

  const style = {
    left: `${sidebarWidth + settingsMenuWidth + SETTINGS_MAIN_MARGIN_WIDTH + 0.5 * (tableWidth - BAR_WIDTH)}px`,
  }

  useEffect(() => {
    if (!tableElement || !sidebarElement) {
      handleClose()
    }
  }, [])

  const handleClose = () => {
    dispatch(unselectAccountUsers())
  }

  const handleDelete = () => {
    dispatch(deleteAccountUsers({ accountUserIds: selectedAccountUserIds }))
  }

  const handleOpenManageWorkspaceAccessPopup = () => {
    dispatch(openManageWorkspaceAccessPopup())
  }

  const renderManageWorkspaceAccess = () => {
    return (
      <Button
        caption="Manage workspace access"
        icon={<Add />}
        styleType="gray-subtle"
        size="small"
        onClick={handleOpenManageWorkspaceAccessPopup}
      />
    )
  }

  const renderDelete = () => {
    return (
      <Button
        caption={numberOfSelectedAccountUsers === 1 ? 'Remove 1 user' : `Remove ${numberOfSelectedAccountUsers} users`}
        icon={<Delete />}
        styleType="danger"
        size="small"
        onClick={handleDelete}
      />
    )
  }

  return (
    <div
      className="AccountUsersBulkActionBar"
      style={style}
    >
      <div className="AccountUsersBulkActionBar__left">
        <Close
          onClick={handleClose}
        />
        <div className="AccountUsersBulkActionBar__selected">
          {numberOfSelectedAccountUsers === 1 ? '1 user selected' : `${numberOfSelectedAccountUsers} users selected`}
        </div>
      </div>
      <div className="AccountUsersBulkActionBar__right">
        {renderManageWorkspaceAccess()}
        {shouldAllowToDelete && renderDelete()}
      </div>
    </div>
  )
}

export default AccountUsersBulkActionBar
